import styled from 'styled-components';
import { down } from 'styled-breakpoints';

export const Container = styled.div`
  width: 100%;
  overflow: hidden;
  margin-bottom: 1.5rem;
  position: relative;
  background: linear-gradient(135deg, #667eea, #764ba2);
  aspect-ratio: 16 / 3;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  > a {
    display: block;
    height: 100%;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  ${down('md')} {
    margin-bottom: 1rem;
    aspect-ratio: 16 / 5;
  }
`;

export const Track = styled.div<{ $currentSlide: number; $total: number }>`
  display: flex;
  width: ${({ $total }) => $total * 100}%;
  height: 100%;
  transform: translateX(
    ${({ $currentSlide, $total }) => -($currentSlide * 100) / $total}%
  );
  transition: transform 0.5s ease-in-out;
`;

export const Slide = styled.div`
  flex: 1 0 0%;
  min-width: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  a {
    display: block;
    height: 100%;
  }
`;

export const Dots = styled.div`
  position: absolute;
  bottom: 0.75rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.375rem;
  z-index: 1;
`;

export const Dot = styled.div<{ $active?: boolean }>`
  width: ${({ $active }) => ($active ? '1.25rem' : '0.375rem')};
  height: 0.375rem;
  border-radius: 0.1875rem;
  background: ${({ $active }) =>
    $active ? 'white' : 'rgba(255, 255, 255, 0.4)'};
  transition: all 0.3s ease;
  cursor: pointer;
`;
